import * as BABYLON from '@babylonjs/core';
import { ShadowOnlyMaterial } from '@babylonjs/materials';
import { pipe } from 'fp-ts/lib/function';
import * as O from 'fp-ts/Option';
export const SHADOW_FLOOR_MESH_NAME = 'shadow-floor';
export const SHADOW_FLOOR_MATERIAL_NAME = 'shadow-floor-material';
/**
 * Create an invisible floor solely to allow shadow.
 *
 * Used when displaying a single product or furniture outside of the context of a proper Room.
 *
 * The mesh will be created with the name SHADOW_FLOOR_MESH_NAME and the material with the name SHADOW_FLOOR_MATERIAL_NAME, both exported from this file.
 */
export function create(scene) {
    const existing = scene.getMeshByName(SHADOW_FLOOR_MESH_NAME);
    if (existing === undefined || existing === null) {
        const groundMesh = BABYLON.MeshBuilder.CreatePlane(SHADOW_FLOOR_MESH_NAME, { size: 25 }, scene);
        groundMesh.receiveShadows = true;
        const groundMat = new ShadowOnlyMaterial(SHADOW_FLOOR_MATERIAL_NAME, scene);
        groundMat.backFaceCulling = false;
        groundMat.alpha = 0.5;
        groundMesh.material = groundMat;
        groundMesh.rotation = new BABYLON.Vector3(Math.PI / 2, 0, 0);
        groundMesh.position = new BABYLON.Vector3(0, 0, 0);
        // since we are not going to be moving the ground, we freeze it for better performance
        groundMesh.freezeWorldMatrix();
        return groundMesh;
    }
    else {
        return existing;
    }
}
export const get = (scene) => pipe(scene.getMeshByName(SHADOW_FLOOR_MESH_NAME), O.fromNullable);
